import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useLang } from "@/contexts/LangContext";

/**
 * Smart back button. Prefers explicit `to` (a path or -1) and label.
 * Falls back to history back.
 */
export default function BackButton({ to, label, className = "" }) {
  const nav = useNavigate();
  const { isRTL, t } = useLang();
  const Arrow = isRTL ? ArrowRight : ArrowLeft;
  const onClick = () => {
    if (to === -1 || to == null) nav(-1);
    else nav(to);
  };
  return (
    <button
      type="button"
      data-testid="back-btn"
      onClick={onClick}
      className={`inline-flex items-center gap-2 text-sm font-semibold text-emerald-900 hover:text-amber-700 transition ${className}`}
    >
      <Arrow className="w-4 h-4" />
      <span>{label || t.common.back}</span>
    </button>
  );
}
